export enum Errors {
  InvalidEmail = 'auth/invalid-email',
  UserNotFound = 'auth/user-not-found',
  WrongPassword = 'auth/wrong-password',
  InvalidCredential = 'auth/invalid-credential',
  AccountNotActivated = 'account-not-activated',
  NetworkRequestFailed = 'auth/network-request-failed',
  ExpiredActionCode = 'auth/expired-action-code',
  InvalidActionCode = 'auth/invalid-action-code',
  UserDisabled = 'auth/user-disabled',
  WeakPassword = 'auth/weak-password',
  AuthEmailNotFound = 'auth-email-not-found',
  RequiresRecentLogin = 'auth/requires-recent-login',
  InvalidDeviceContext = 'auth/invalid-device-context',
  PopupClosedByUser = 'auth/popup-closed-by-user',
  CancelledPopupRequest = 'auth/cancelled-popup-request',
  MultiFactorAuthRequired = 'auth/multi-factor-auth-required',
  InvalidVerificationCode = 'auth/invalid-verification-code',
  MissingVerificationCode = 'auth/missing-verification-code',
  InvalidMultiFactorSession = 'auth/invalid-multi-factor-session',
  MultiFactorInfoNotFound = 'auth/multi-factor-info-not-found',
  NullUser = 'auth/null-user',
  UserTokenExpired = 'auth/user-token-expired',
  TooManyRequests = 'auth/too-many-requests',
  QuotaExceeded = 'auth/quota-exceeded',
  SecondFactorLimitExceeded = 'auth/maximum-second-factor-count-exceeded',
  PasswordDoesNotMeetRequirements = 'auth/password-does-not-meet-requirements',
  InternalError = 'auth/internal-error',
}
